import { FC } from 'react'
import TextFieldIcon from './TextFieldIcon'
import NumberFieldIcon from './NumberFieldIcon'
import DropdownIcon from './DropdownIcon'
import CheckboxIcon from './CheckboxIcon'
import TextAreaIcon from './TextAreaIcon'
import DateIcon from './DateIcon'
import BirthDateIcon from './BirthDateIcon'
import PhoneIcon from './PhoneIcon'
import EmailIcon from './EmailIcon'
import UrlIcon from './UrlIcon'
import CountryIcon from './CountryIcon'
import PlayerPositionIcon from './PlayerPositionIcon'

export interface QuestionTypeIconProps {
  size?: number
  color?: string
  className?: string
}

// Export individual icon components
export {
  TextFieldIcon,
  NumberFieldIcon,
  DropdownIcon,
  CheckboxIcon,
  TextAreaIcon,
  DateIcon,
  BirthDateIcon,
  PhoneIcon,
  EmailIcon,
  UrlIcon,
  CountryIcon,
  PlayerPositionIcon,
}

// Question type mapping for icon lookup
export const questionTypeIconMap: Record<string, FC<QuestionTypeIconProps>> = {
  text: TextFieldIcon,
  number: NumberFieldIcon,
  dropdown: DropdownIcon,
  checkbox: CheckboxIcon,
  textarea: TextAreaIcon,
  date: DateIcon,
  birthdate: BirthDateIcon,
  phone: PhoneIcon,
  email: EmailIcon,
  url: UrlIcon,
  country: CountryIcon,
  player_position: PlayerPositionIcon,
}

// Default fallback icon (using TextFieldIcon as default)
export const DefaultQuestionIcon = TextFieldIcon
